import React, { useEffect, useContext } from 'react'
import { View, Text, StyleSheet } from 'react-native';
import { useTranslation } from 'react-i18next';

import '../../../../style/css/rule.css'
import { routeContact } from '../../../../style/css/CmnStyle';
import { hpContext } from '../../HPContext'


// プライバシーポリシー
function PrivacyPolicy() {
  const { t, i18n } = useTranslation();

  const ReactGA = useContext(hpContext).ReactGA;

  const scrollHeadHeight = useContext(hpContext).scrollHeadHeight;
  const isWide = useContext(hpContext).isWide;

  useEffect(() => {
    // ログ：ページ
    ReactGA.event("pagePrivacyPolicy");
  }, [])


  return (
    <View style={{marginTop: scrollHeadHeight}}>

      <div className={isWide? 'wide-rule-wrap' : 'rule-wrap'}>

        <h1 className='rule-title'>{t('policy.title')}</h1>

        <div className='article'>
          <h2 className='article-title'>{t('policy.title')}</h2>
          <p className='article-content'>{t('policy.premise')}</p>
        </div>

        <div className='article'>
          <h2 className='article-title'>{t('policy.a1.title')}</h2>
          <div className='article-content'>
            <ul className='article-ul'>
              <li>{t('policy.a1.l1')}</li>
              <li>{t('policy.a1.l2')}</li>
            </ul>
          </div>
        </div>

        <div className='article'>
          <h2 className='article-title'>{t('policy.a2.title')}</h2>
          <div className='article-content'>
            <p>{t('policy.a2.premise')}</p>
            <ul className='article-ul'>
              <li>{t('policy.a2.l1')}</li>
              <li>{t('policy.a2.l2')}</li>
              <li>{t('policy.a2.l3')}</li>
              <li>{t('policy.a2.l4')}</li>
            </ul>
          </div>
        </div>

        <div className='article'>
          <h2 className='article-title'>{t('policy.a3.title')}</h2>
          <div className='article-content'>
            <p>{t('policy.a3.premise')}</p>
            <ul className='article-ul'>
              <li>{t('policy.a3.l1')}</li>
              <li>{t('policy.a3.l2')}</li>
              <li>{t('policy.a3.l3')}</li>
              <li>{t('policy.a3.l4')}</li>
              <li>{t('policy.a3.l5')}</li>
              <li>{t('policy.a3.l6')}</li>
              <li>{t('policy.a3.l7')}</li>
              <li>{t('policy.a3.l8')}</li>
              <li>{t('policy.a3.l9')}</li>
              <li>{t('policy.a3.l10')}</li>
              <li>{t('policy.a3.l11')}</li>
              <li>{t('policy.a3.l12')}</li>
              <li>{t('policy.a3.l13')}</li>
              <li>{t('policy.a3.l14')}</li>
            </ul>
          </div>
        </div>

        <div className='article'>
          <h2 className='article-title'>{t('policy.a4.title')}</h2>
          <div className='article-content'>
            <p>{t('policy.a4.premise')}</p>
            <ul className='article-ul'>
              <li>{t('policy.a4.l1')}</li>
              <li>{t('policy.a4.l2')}</li>
              <li>{t('policy.a4.l3')}</li>
              <li>{t('policy.a4.l4')}</li>
              <li>{t('policy.a4.l5')}</li>
            </ul>
          </div>
        </div>

        <div className='article'>
          <h2 className='article-title'>{t('policy.a5.title')}</h2>
          <div className='article-content'>
            <ul className='article-ul'>
              <li>{t('policy.a5.l1')}</li>
              <li>{t('policy.a5.l2')}</li>
            </ul>
          </div>
        </div>

        <div className='article'>
          <h2 className='article-title'>{t('policy.a6.title')}</h2>
          <div className='article-content'>
            <p>{t('policy.a6.l1')}</p>
          </div>
        </div>

        <div className='article'>
          <h2 className='article-title'>{t('policy.a7.title')}</h2>
          <div className='article-content'>
            <ul className='article-ul'>
              <li>{t('policy.a7.l1')}</li>
              <li>{t('policy.a7.l2')}</li>
            </ul>
          </div>
        </div>

        <div className='article'>
          <h2 className='article-title'>{t('policy.a8.title')}</h2>
          <div className='article-content'>
            <p>{t('policy.a8.l1')}</p>
          </div>
        </div>

        <div className='article'>
          <h2 className='article-title'>{t('policy.a9.title')}</h2>
          <div className='article-content'>
            <p>{t('policy.a9.premise')}</p>
            <ul className='article-ul'>
              <li>{t('policy.a9.l1')}</li>
              <li>{t('policy.a9.l2')}</li>
              <li>{t('policy.a9.l3')}</li>
            </ul>
          </div>
        </div>

        <div className='article'>
          <h2 className='article-title'>{t('policy.a10.title')}</h2>
          <div className='article-content'>
            <p>{t('policy.a10.l1')}</p>
          </div>
        </div>

        <div className='article'>
          <h2 className='article-title'>{t('policy.a11.title')}</h2>
          <div className='article-content'>
            <ul className='article-ul'>
              <li>{t('policy.a11.l1')}</li>
              <li>{t('policy.a11.l2')}</li>
            </ul>
          </div>
        </div>

        <div className='article'>
          <h2 className='article-title'>{t('policy.a12.title')}</h2>
          <div className='article-content'>
            <p>{t('policy.a12.l1')}</p>
          </div>
        </div>

        <div className='article'>
          <h2 className='article-title'>{t('policy.a13.title')}</h2>
          <div className='article-content'>
            <p>
              {t('policy.a13.short1')}
              <a href={routeContact} target='_blank'>{t('policy.a13.link')}</a>
              {t('policy.a13.short2')}
            </p>
          </div>
        </div>

        <div className='article history-wrap'>
          <h3 className='history-title'>{t('policy.history.title')}</h3>
          <ul className='history'>
            <li>{t('policy.history.v1')}</li>
            <li>{t('policy.history.v2')}</li>
          </ul>
        </div>

      </div>

    </View>
  );
}

export default PrivacyPolicy;